// extracted by mini-css-extract-plugin
export default {"mCard":"gB-z","image":"hB-z","imageNoBackground":"iB-z","imageHasCategory":"jB-z","fullWidth":"kB-z"};